import { ConfirmationDialogProps } from './ConfirmationDialog'

export { default } from './ConfirmationDialog'

export type ConfirmationDialogProps = ConfirmationDialogProps
